export const ANALYSIS_RESULT_ITEM_LOGO_SIZE = 84
export const CV_ANALYSIS_RESULT_ITEM_LOGO_SIZE = 60

export const ANALYSIS_POPULAR_ITEM_LOGO_SIZE = {
  PC: 92,
  MO: 60,
}
